import { classnames } from '@/helpers';
import { twMerge } from 'tailwind-merge';
import Icon from '../icons/Icon';
import { IconProps } from '../icons/types';

type IconStatusType = 'success' | 'not_included' | 'warning' | 'error' | 'countdown';

const ICON_STATUS_STYLES_MAP: {
  [key in IconStatusType]: string;
} = {
  success: 'bg-bg_positive_bold',
  not_included: 'bg-bg_negative_bold',
  warning: 'bg-bg_notice_bold',
  error: 'bg-bg_negative_bold',
  countdown: 'bg-bg_info_bold',
};

const ICON_STATUS_ICON_MAP: {
  [key in IconStatusType]: IconProps;
} = {
  success: { variant: 'check', color: 'fg_alwaysLight' },
  not_included: { variant: 'close', color: 'fg_alwaysLight' },
  warning: { variant: 'warning', color: 'fg_alwaysDark' },
  error: { variant: 'error', color: 'fg_alwaysLight' },
  countdown: { variant: 'countdown', color: 'fg_alwaysLight' },
};

export const StatusIcon = ({ type, className = '' }: { type: IconStatusType; className?: string }) => {
  return (
    <div
      className={twMerge(
        classnames(
          'p-2xs inline-flex flex-shrink-0 items-center justify-center rounded-full',
          ICON_STATUS_STYLES_MAP[type],
          className,
        ),
      )}>
      <Icon {...ICON_STATUS_ICON_MAP[type]} style={{ width: 16, height: 16 }} />
    </div>
  );
};
